import React from 'react';

type Props = {
  showEditButton: boolean,
  isFormValid?: boolean,
  disableButtons?: boolean,
  onSubmitButtonClick: (event?: any) => void,
  onDeleteButtonClick?: () => void,
  onCloseButtonClick: () => void,
  submitButtonText: string,
  deleteButtonText?: string,
  isLoading?: boolean,
}

const ModalControls = (props: Props) => {
  const {
    disableButtons, showEditButton, onSubmitButtonClick, onDeleteButtonClick, isFormValid,
    submitButtonText, deleteButtonText, onCloseButtonClick, isLoading,
  } = props;

  return (
    <>
      {showEditButton ? (
        <button
          type="button"
          className="btn btn-primary secondary-color"
          style={{ position: 'absolute', left: 17 }}
          disabled={disableButtons}
          onClick={onDeleteButtonClick}
        >
          {deleteButtonText}
        </button>
      ) : null}
      <button
        type="button"
        className="btn btn-secondary js-close"
        onClick={onCloseButtonClick}
      >
        Close
      </button>
      <button
        type="button"
        className="btn btn-primary primary-color"
        disabled={isFormValid || disableButtons}
        onClick={onSubmitButtonClick}
      >
        {isLoading && (
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        )}
        {submitButtonText}
      </button>
    </>
  );
};

export default ModalControls;
